import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import * as COLORS from '../styles/colors/colors';
export var ROOT_PREFIX = 'EmbersMessage';
export var StyledMessage = styled('div')(_defineProperty({
  display: 'flex',
  alignItems: 'center',
  padding: 24,
  borderRadius: 4
}, "&.".concat(ROOT_PREFIX), {
  '&-root': _defineProperty(_defineProperty({
    '.EmbersStatusIcon-text': {
      color: "".concat(COLORS.PROMETHEAN_TEXT, " !important")
    }
  }, "&.".concat(ROOT_PREFIX, "-hasExtraText"), {
    flexDirection: 'column',
    alignItems: 'flex-start'
  }), ".".concat(ROOT_PREFIX, "-header"), {
    '.EmbersStatusIcon-text': {
      color: "".concat(COLORS.PROMETHEAN_TEXT_HEADER, " !important")
    }
  }),
  '&-large': _defineProperty({
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 40,
    paddingBottom: 40
  }, "&.".concat(ROOT_PREFIX, "-hasExtraText"), _defineProperty({
    paddingTop: 32,
    '.EmbersStatusIcon': {
      '.EmbersStatusIcon-text': {
        paddingTop: 8
      }
    }
  }, ".".concat(ROOT_PREFIX, "-extraText"), {
    paddingLeft: 50
  })),
  '&-medium': _defineProperty({}, "&.".concat(ROOT_PREFIX, "-hasExtraText"), _defineProperty({}, "& .".concat(ROOT_PREFIX, "-extraText"), {
    paddingLeft: 28
  })),
  '&-inline': {
    paddingTop: 16,
    paddingBottom: 16
  },
  '&-hasClose': _defineProperty({
    position: 'relative',
    paddingRight: 24,
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }, "& .".concat(ROOT_PREFIX, "-close"), {
    cursor: 'pointer',
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    '& .icon-close': {
      color: COLORS.PROMETHEAN_TEXT,
      fontSize: 16,
      width: 16,
      height: 16,
      border: '2px solid transparent',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center'
    },
    ':focus-visible > .icon-close': {
      borderColor: COLORS.PROMETHEAN_BLUE
    }
  }),
  '&-center': {
    justifyContent: 'center'
  },
  '&-error': {
    backgroundColor: COLORS.PROMETHEAN_ERROR_BG
  },
  '&-success': {
    backgroundColor: COLORS.PROMETHEAN_SUCCESS_GREEN_BG
  },
  '&-alert': {
    backgroundColor: COLORS.PROMETHEAN_ERROR_BG
  },
  '&-destructiveSuccess': {
    backgroundColor: COLORS.PROMETHEAN_NEUTRAL_LIGHT_GREY
  }
}));